/** The host Debian's apt sources download from; the agent's instructions offer apt only when it is allowed. */
export const DEBIAN_APT_HOST = 'deb.debian.org';

/**
 * Shared by the environment UI and the sandbox firewall, including package download hosts.
 * Cargo includes rustup's hosts: the image has no Rust, and the detected setup installs it.
 */
export const CODE_PACKAGE_REGISTRIES = [
  {
    name: 'Node.js · npm / Yarn',
    hosts: [
      'registry.npmjs.org',
      'registry.yarnpkg.com',
      // Where Corepack downloads Yarn 2 and later, for a `packageManager: yarn@4` repository.
      'repo.yarnpkg.com',
      'nodejs.org',
      'binaries.prisma.sh',
      // Cypress's install script downloads its binary from here.
      'download.cypress.io',
      'cdn.cypress.io',
    ],
  },
  { name: 'JSR', hosts: ['jsr.io', 'npm.jsr.io'] },
  { name: 'Python · PyPI', hosts: ['pypi.org', 'files.pythonhosted.org', 'download.pytorch.org'] },
  { name: 'Conda', hosts: ['conda.anaconda.org', 'repo.anaconda.com'] },
  {
    name: 'Rust · Cargo',
    hosts: [
      'crates.io',
      'index.crates.io',
      'static.crates.io',
      'sh.rustup.rs',
      'static.rust-lang.org',
    ],
  },
  { name: 'RubyGems', hosts: ['rubygems.org', 'api.rubygems.org', 'index.rubygems.org'] },
  { name: 'Go modules', hosts: ['proxy.golang.org', 'sum.golang.org', 'index.golang.org'] },
  {
    name: 'Java · Maven / Gradle',
    hosts: [
      'repo1.maven.org',
      'repo.maven.apache.org',
      'services.gradle.org',
      'downloads.gradle.org',
      'plugins.gradle.org',
      'plugins-artifacts.gradle.org',
      // Google's Maven repository, which Android and many Kotlin builds need.
      'maven.google.com',
      'dl.google.com',
    ],
  },
  { name: 'PHP · Composer', hosts: ['repo.packagist.org'] },
  { name: 'Debian · apt', hosts: [DEBIAN_APT_HOST] },
  {
    name: 'Playwright browsers',
    hosts: ['cdn.playwright.dev', 'playwright.download.prss.microsoft.com'],
  },
  {
    // Script tags, icon fonts and Fontsource in pages an app serves. These serve
    // any published package, so they sit behind the preset, not in the defaults.
    name: 'Web CDNs',
    hosts: ['cdn.jsdelivr.net', 'unpkg.com', 'cdnjs.cloudflare.com'],
  },
] as const;

export const CODE_PACKAGE_REGISTRY_HOSTS = CODE_PACKAGE_REGISTRIES.flatMap<string>(
  ({ hosts }) => hosts,
);
